import React from 'react';
import { Tooltip } from '@fiverr-private/tooltip';
import { InfoCircleIcon } from '@fiverr-private/visuals';
import { translate } from '@fiverr-private/i18n-react';
import { ComplianceType, ComplianceTypes } from './types';

const InfoIcon = ({
    monthlyCredit,
    complianceType = ComplianceTypes.BACKGROUND_CHECK,
}: {
    monthlyCredit?: string;
    complianceType: ComplianceType;
}) => (
    <Tooltip
        content={translate(`compliance.info_icon.${complianceType}_info`, {
            params: { monthlyCredit: monthlyCredit || '0' },
        })}
        position="bottom"
        anchorProps={{ display: 'inlineFlex' }}
    >
        <InfoCircleIcon size="xs" color="grey_800" />
    </Tooltip>
);
export default InfoIcon;
